import { createFileRoute, Link } from "@tanstack/react-router";
import { ProsePage } from "../components/prose-page.tsx";

export const Route = createFileRoute("/contact")({ component: ContactPage });

function ContactPage() {
	return (
		<ProsePage
			title="Contact"
			intro="A real person reads these. Please say which business you are asking about."
		>
			<h2>Business registrations and listings</h2>
			<p>
				If your registration is taking longer than two business days, or a
				listing was removed and you would like to know why, email{" "}
				<a href="mailto:support@nwgaconnect.local">support@nwgaconnect.local</a>
				. Removals and suspensions always come with a written reason — check the
				address you registered with.
			</p>

			<h2>Appealing a decision</h2>
			<p>
				Reply to the email you were sent, or write to the address above. Say
				what you have changed since, and a reviewer will look again.
			</p>

			<h2>Something wrong with a listing</h2>
			<p>
				If a posting looks fraudulent, misleading, or is not a real job, tell us
				and we will look at it. Include the link.
			</p>

			<h2>Everything else</h2>
			<p>
				For anything about the platform itself — a bug, an accessibility
				problem, a suggestion — the same address works. If a page is unusable
				for you, that is a bug and we would like to hear about it.
			</p>

			<p>
				<Link to="/businesses/register">
					If you are hiring, register your business and start posting.
				</Link>
			</p>
		</ProsePage>
	);
}
